"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#5E5E5E' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c;
    return (react_1.default.createElement("svg", { viewBox: "0 0 32 32", width: scale * 32, height: scale * 32, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333zM2.667 16h26.666", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M16 2.667A20.4 20.4 0 0 1 21.333 16 20.4 20.4 0 0 1 16 29.333 20.4 20.4 0 0 1 10.667 16 20.4 20.4 0 0 1 16 2.667v0z", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Icon;
//# sourceMappingURL=Globe.js.map